import { render, staticRenderFns } from "./ClockIcon.vue?vue&type=template&id=3b3a64d8&"
import script from "./ClockIcon.vue?vue&type=script&lang=ts&"
export * from "./ClockIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3b3a64d8', component.options)
    } else {
      api.reload('3b3a64d8', component.options)
    }
    module.hot.accept("./ClockIcon.vue?vue&type=template&id=3b3a64d8&", function () {
      api.rerender('3b3a64d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/icons/ClockIcon.vue"
export default component.exports